(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('article-share-copy')) {
    customElements.define(
      'article-share-copy',
      class ArticleShareCopy extends HTMLElement {
        connectedCallback() {
          if (!navigator.clipboard) return;
          this.hidden = false;
          this.querySelector('button').addEventListener('click', () => this.copy());
        }

        async copy() {
          const copyLabel = this.querySelector('[data-copy-label]');
          const copiedLabel = this.querySelector('[data-copied-label]');
          const status = this.querySelector('[data-copy-status]');
          try {
            await navigator.clipboard.writeText(this.dataset.url);
            copyLabel.hidden = true;
            copiedLabel.hidden = false;
            status.textContent = copiedLabel.textContent;
            clearTimeout(this.resetTimer);
            this.resetTimer = setTimeout(() => {
              copyLabel.hidden = false;
              copiedLabel.hidden = true;
              status.textContent = '';
            }, 2000);
          } catch (error) {
            console.error('Copy link failed', error);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["carousel-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('carousel-slider')) {
    const EDGE_TOLERANCE_PX = 4;
    const DRAG_THRESHOLD_PX = 6;
    const SNAP_RELEASE_FALLBACK_MS = 600;
    const FORM_CONTROLS = 'input, select, textarea, [contenteditable="true"]';

    const scrollBehavior = () =>
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

    class CarouselSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-slider-track]');
        if (!this.track) return;
        this.prev = this.querySelector('[data-slider-prev]');
        this.next = this.querySelector('[data-slider-next]');

        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });
        this.prev?.addEventListener('click', () => this.step(-1), { signal });
        this.next?.addEventListener('click', () => this.step(1), { signal });
        this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
        this.track.addEventListener('pointerdown', (event) => this.onPointerDown(event), { signal });
        this.track.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
        this.track.addEventListener('click', (event) => this.suppressClickAfterDrag(event), { capture: true, signal });
        this.addEventListener('shopify:block:select', (event) => this.revealSlide(event.target), { signal });

        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
      }

      get direction() {
        return getComputedStyle(this).direction === 'rtl' ? -1 : 1;
      }

      get stepSize() {
        const [first, second] = this.track.children;
        if (!first) return this.track.clientWidth;
        return second ? Math.abs(second.offsetLeft - first.offsetLeft) : first.offsetWidth;
      }

      step(direction) {
        this.track.scrollBy({ left: direction * this.direction * this.stepSize, behavior: scrollBehavior() });
      }

      onKeydown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (event.target.closest(FORM_CONTROLS)) return;
        event.preventDefault();
        const visualDirection = event.key === 'ArrowRight' ? 1 : -1;
        this.track.scrollBy({ left: visualDirection * this.stepSize, behavior: scrollBehavior() });
      }

      onPointerDown(event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (getComputedStyle(this.track).overflowX === 'hidden') return;
        const startX = event.clientX;
        const startScroll = this.track.scrollLeft;
        this.hasDragged = false;

        const onMove = (moveEvent) => {
          const distance = moveEvent.clientX - startX;
          if (!this.hasDragged && Math.abs(distance) < DRAG_THRESHOLD_PX) return;
          this.hasDragged = true;
          this.dataset.dragging = '';
          this.track.scrollLeft = startScroll - distance;
        };

        const onUp = () => {
          window.removeEventListener('pointermove', onMove);
          window.removeEventListener('pointerup', onUp);
          if (this.hasDragged) this.snapToNearest();
        };

        window.addEventListener('pointermove', onMove);
        window.addEventListener('pointerup', onUp);
      }

      suppressClickAfterDrag(event) {
        if (!this.hasDragged) return;
        event.preventDefault();
        event.stopPropagation();
        this.hasDragged = false;
      }

      snapToNearest() {
        const index = Math.round(Math.abs(this.track.scrollLeft) / this.stepSize);
        const release = () => delete this.dataset.dragging;
        this.track.addEventListener('scrollend', release, { once: true });
        setTimeout(release, SNAP_RELEASE_FALLBACK_MS);
        this.track.scrollTo({ left: this.direction * index * this.stepSize, behavior: scrollBehavior() });
      }

      revealSlide(target) {
        const slide = [...this.track.children].find((child) => child.contains(target));
        if (!slide) return;
        this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: scrollBehavior() });
      }

      update() {
        const { scrollWidth, clientWidth } = this.track;
        const position = Math.abs(this.track.scrollLeft);
        const maxScroll = scrollWidth - clientWidth;

        this.dataset.scrollable = String(maxScroll > EDGE_TOLERANCE_PX);
        if (this.prev) this.prev.disabled = position <= EDGE_TOLERANCE_PX;
        if (this.next) this.next.disabled = position >= maxScroll - EDGE_TOLERANCE_PX;
        if (this.prev?.disabled && document.activeElement === this.prev) this.next?.focus();
        if (this.next?.disabled && document.activeElement === this.next) this.prev?.focus();

        if (scrollWidth > 0) {
          this.style.setProperty('--carousel-progress-size', String(clientWidth / scrollWidth));
          this.style.setProperty('--carousel-progress-start', String(position / scrollWidth));
        }

        const anchor = this.dataset.arrowAnchor && this.track.querySelector(this.dataset.arrowAnchor);
        if (anchor) this.style.setProperty('--carousel-arrow-top', `${anchor.offsetHeight / 2}px`);
      }
    }

    customElements.define('carousel-slider', CarouselSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-region"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('cart-region')) return;

    const STEP_DEBOUNCE_MS = 350;

    const escapeSelector = (value) => (window.CSS?.escape ? window.CSS.escape(value) : String(value).replace(/["\\]/g, '\\$&'));

    const cartSectionIds = () => [
      ...new Set(Array.from(document.querySelectorAll('cart-region[data-cart-section]'), (el) => el.dataset.cartSection)),
    ];

    const fetchCartSections = async (ids) => {
      const url = `${window.theme.routes.cart}?sections=${ids.map(encodeURIComponent).join(',')}`;
      // No Accept: application/json here — with that header Shopify answers the Cart AJAX API
      // (the cart object) instead of the Section Rendering API, so every id would be missing
      // from the response and the drawer would keep its stale, empty markup.
      const response = await fetch(url);
      if (!response.ok) throw new Error(window.theme.strings.error);
      return response.json();
    };

    const replaceRegion = (id, html) => {
      const selector = `cart-region[data-cart-section="${escapeSelector(id)}"]`;
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      const current = document.querySelector(selector);
      if (!next || !current) return;

      const active = document.activeElement;
      const hadFocus = current.contains(active);
      const focusKey = hadFocus ? active.closest('[data-focus-key]')?.dataset.focusKey : null;

      const replacement = document.importNode(next, true);
      current.replaceWith(replacement);

      if (hadFocus) {
        const target =
          (focusKey && replacement.querySelector(`[data-focus-key="${escapeSelector(focusKey)}"]:not(:disabled)`)) ||
          replacement.querySelector('[data-cart-focus-fallback]');
        target?.focus();
      }

      const status = document.querySelector(`[data-cart-status="${escapeSelector(id)}"]`);
      const summary = replacement.querySelector('[data-cart-live-summary]');
      if (status && summary) status.textContent = summary.textContent.trim();
    };

    let renderToken = 0;

    const renderCartSections = async (sections = {}) => {
      const ids = cartSectionIds();
      if (!ids.length) return;
      const token = ++renderToken;
      let html = { ...sections };
      const missing = ids.filter((id) => typeof html[id] !== 'string');
      if (missing.length) {
        try {
          html = { ...html, ...(await fetchCartSections(missing)) };
        } catch (error) {
          console.error(error);
        }
      }
      if (token !== renderToken) return;
      ids.forEach((id) => {
        if (typeof html[id] === 'string') replaceRegion(id, html[id]);
      });
    };

    document.addEventListener('cart:updated', (event) => renderCartSections(event.detail?.sections || {}));

    let queue = Promise.resolve();
    const enqueue = (task) => {
      queue = queue.then(task, task);
      return queue;
    };

    const lineIndexForKey = (key) => {
      const line = document.querySelector(`cart-region [data-key="${escapeSelector(key)}"]`);
      return line ? Number(line.dataset.line) : null;
    };

    class CartRegion extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-cart-update-button]').forEach((button) => {
          button.hidden = true;
        });
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('submit', this.onSubmit);
      }

      disconnectedCallback() {
        clearTimeout(this.stepTimer);
      }

      onClick = (event) => {
        const step = event.target.closest('[data-cart-quantity-step]');
        if (step) {
          const input = step.closest('[data-line]')?.querySelector('[data-cart-quantity-input]');
          if (input) this.stepQuantity(input, Number(step.dataset.cartQuantityStep));
          return;
        }
        const remove = event.target.closest('[data-cart-remove]');
        if (remove) {
          event.preventDefault();
          this.updateLine(remove.closest('[data-line]'), 0);
        }
      };

      onChange = (event) => {
        if (event.target.matches('[data-cart-quantity-input]')) this.commitInput(event.target);
        else if (event.target.matches('[data-cart-note]')) this.saveNote(event.target.value);
      };

      onKeydown = (event) => {
        if (event.key !== 'Enter' || !event.target.matches('[data-cart-quantity-input]')) return;
        event.preventDefault();
        this.commitInput(event.target);
      };

      onSubmit = (event) => {
        if (event.submitter?.name !== 'checkout') event.preventDefault();
      };

      stepQuantity(input, delta) {
        const max = input.max ? Number(input.max) : Infinity;
        const current = Number.parseInt(input.value, 10) || 0;
        input.value = String(Math.min(max, Math.max(0, current + delta)));
        clearTimeout(this.stepTimer);
        this.stepTimer = setTimeout(() => this.commitInput(input), STEP_DEBOUNCE_MS);
      }

      commitInput(input) {
        clearTimeout(this.stepTimer);
        if (input.value.trim() === '') {
          input.value = input.defaultValue;
          return;
        }
        const max = input.max ? Number(input.max) : Infinity;
        const quantity = Math.min(max, Math.max(0, Number.parseInt(input.value, 10) || 0));
        input.value = String(quantity);
        if (input.value === input.defaultValue) return;
        input.defaultValue = input.value;
        this.updateLine(input.closest('[data-line]'), quantity);
      }

      updateLine(lineElement, quantity) {
        if (!lineElement || !window.theme?.cart) return;
        const key = lineElement.dataset.key;
        const restore = quantity === 0 ? this.snapshotLine(lineElement) : null;
        lineElement.classList.add('cart-line-item--busy');
        this.setAttribute('aria-busy', 'true');

        enqueue(async () => {
          const line = lineIndexForKey(key);
          if (line === null) return;
          try {
            await window.theme.cart.change(line, quantity, { sections: cartSectionIds() });
            if (restore) this.offerUndo(restore);
          } catch (error) {
            window.theme.toast(error.message || window.theme.strings.error, { type: 'error' });
            await renderCartSections();
          } finally {
            if (this.isConnected) this.removeAttribute('aria-busy');
          }
        });
      }

      snapshotLine(lineElement) {
        const { variantId, quantity, properties, sellingPlan, removedMessage } = lineElement.dataset;
        if (!variantId) return null;
        const item = { id: Number(variantId), quantity: Number(quantity) || 1 };
        if (properties) {
          try {
            item.properties = JSON.parse(properties);
          } catch {}
        }
        if (sellingPlan) item.selling_plan = Number(sellingPlan);
        const undoLabel = lineElement.closest('[data-undo-label]')?.dataset.undoLabel;
        return { item, message: removedMessage, undoLabel };
      }

      offerUndo({ item, message, undoLabel }) {
        if (!message) return;
        const action = undoLabel
          ? { label: undoLabel, onClick: () => window.theme.cart.add(item, { notify: false }).catch(() => {}) }
          : undefined;
        window.theme.toast(message, { type: 'info', action });
      }

      async saveNote(note) {
        try {
          const response = await fetch(`${window.theme.routes.cartUpdate}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note }),
          });
          if (!response.ok) throw new Error(window.theme.strings.error);
        } catch (error) {
          window.theme.toast(error.message || window.theme.strings.error, { type: 'error' });
        }
      }
    }

    customElements.define('cart-region', CartRegion);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-upsell"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('cart-upsell')) return;

    const cache = new Map();

    const loadUpsell = (url) => {
      if (!cache.has(url)) {
        const request = fetch(url)
          .then((response) => (response.ok ? response.text() : ''))
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return doc.querySelector('cart-upsell [data-cart-upsell-content]')?.outerHTML || '';
          })
          .catch(() => '');
        cache.set(url, request);
      }
      return cache.get(url);
    };

    class CartUpsell extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick);
        if (this.dataset.url && !this.querySelector('[data-cart-upsell-content]')) this.hydrate();
      }

      async hydrate() {
        const html = await loadUpsell(this.dataset.url);
        if (!html || !this.isConnected || this.querySelector('[data-cart-upsell-content]')) return;
        const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-upsell-content]');
        if (!content) return;
        const inCart = this.dataset.inCart || '';
        content.querySelectorAll('[data-product-id]').forEach((card) => {
          if (inCart.includes(`,${card.dataset.productId},`)) card.remove();
        });
        if (content.querySelector('[data-product-id]')) this.append(document.importNode(content, true));
      }

      onClick = async (event) => {
        const button = event.target.closest('[data-cart-upsell-add]');
        if (!button || !window.theme?.cart) return;
        event.preventDefault();
        button.setAttribute('aria-busy', 'true');
        try {
          await window.theme.cart.add({ id: Number(button.dataset.cartUpsellAdd), quantity: 1 }, { notify: false });
          window.theme.toast(window.theme.strings.addedToCart, { type: 'success' });
        } catch {
          // cart.add already reported the error to the shopper.
        } finally {
          if (button.isConnected) button.removeAttribute('aria-busy');
        }
      };
    }

    customElements.define('cart-upsell', CartUpsell);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-browser"] && !Shopify.designMode) return;
  try {
    class CollectionBrowser extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.input = this.querySelector('[data-browser-input]');
      this.items = [...this.querySelectorAll('[data-browser-item]')];
      this.empty = this.querySelector('[data-browser-empty]');
      this.minLength = Number(this.dataset.minLength) || 2;

      const search = this.querySelector('[data-browser-search]');
      if (search) search.hidden = false;

      this.native = this.querySelector('[data-browser-native]');
      this.input?.addEventListener('input', this.onInput);
      this.native?.addEventListener('change', this.onNativeChange);
      window.addEventListener('pageshow', this.onPageShow);
      this.details?.addEventListener('toggle', this.onToggle);
      this.addEventListener('keydown', this.onKeydown);
      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      this.input?.removeEventListener('input', this.onInput);
      this.native?.removeEventListener('change', this.onNativeChange);
      window.removeEventListener('pageshow', this.onPageShow);
      this.details?.removeEventListener('toggle', this.onToggle);
      this.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('click', this.onDocumentClick);
    }

    close({ focus = false } = {}) {
      if (!this.details?.open) return;
      this.details.open = false;
      if (focus) this.details.querySelector('summary')?.focus();
    }

    onToggle = () => {
      if (!this.details.open) {
        if (this.input) this.input.value = '';
        this.filter('');
        return;
      }
      this.input?.focus();
    };

    onNativeChange = () => {
      if (this.native.value) window.location.assign(this.native.value);
    };

    // Restored from the back/forward cache, the select would still show the collection navigated to.
    onPageShow = () => {
      if (!this.native) return;
      const initial = [...this.native.options].find((option) => option.defaultSelected);
      this.native.value = initial ? initial.value : '';
    };

    onInput = () => {
      this.filter(this.input.value.trim().toLowerCase());
    };

    filter(query) {
      const isActive = query.length >= this.minLength;
      let visible = 0;
      this.items.forEach((item) => {
        const match = !isActive || item.dataset.title.includes(query);
        item.hidden = !match;
        if (match) visible += 1;
      });
      if (this.empty) this.empty.hidden = visible > 0;
    }

    onKeydown = (event) => {
      if (event.key === 'Escape' && this.details?.open) {
        event.preventDefault();
        this.close({ focus: true });
      }
    };

    onDocumentClick = (event) => {
      if (!this.contains(event.target)) this.close();
    };
  }

  if (!customElements.get('collection-browser')) customElements.define('collection-browser', CollectionBrowser);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["countdown-timer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('countdown-timer')) return;

    const URGENT_THRESHOLD_MS = 60 * 60 * 1000;

    class CountdownTimer extends HTMLElement {
      connectedCallback() {
        // Prefer the epoch value: Liquid's `date` filter renders in the SHOP timezone, so an ISO
        // string built with it and suffixed with "Z" is off by the shop's UTC offset. The epoch is
        // timezone-free and therefore the only value we can trust.
        const epoch = Number(this.dataset.deadlineEpoch);
        this.deadline = Number.isFinite(epoch) && epoch > 0
          ? epoch * 1000
          : this.parseDeadline(this.dataset.deadline);
        if (this.deadline === null) {
          this.remove();
          return;
        }
        this.abortController = new AbortController();
        this.timer = null;
        this.lastMinuteAnnounced = null;
        this.values = {
          days: this.querySelector('[data-countdown-days]'),
          hours: this.querySelector('[data-countdown-hours]'),
          minutes: this.querySelector('[data-countdown-minutes]'),
          seconds: this.querySelector('[data-countdown-seconds]'),
        };
        this.status = this.querySelector('[data-countdown-status]');

        document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()), {
          signal: this.abortController.signal,
        });
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        this.abortController?.abort();
      }

      // Accepts ISO-8601 (with zone) or "YYYY-MM-DD HH:MM" which is treated as UTC. Returns ms or null.
      parseDeadline(value) {
        if (!value) return null;
        const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?(Z|[+-]\d{2}:?\d{2})?$/);
        if (!match) return null;
        const [, year, month, day, hour = '0', minute = '0', second = '0', zone] = match;
        let ms = Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second));
        if (zone && zone !== 'Z') {
          const sign = zone.startsWith('-') ? -1 : 1;
          const digits = zone.slice(1).replace(':', '');
          ms -= sign * (Number(digits.slice(0, 2)) * 60 + Number(digits.slice(2))) * 60 * 1000;
        }
        return Number.isNaN(ms) ? null : ms;
      }

      start() {
        this.stop();
        if (this.classList.contains('countdown-timer--expired')) return;
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      tick() {
        const remaining = this.deadline - Date.now();
        if (remaining <= 0) {
          this.expire();
          return;
        }
        const totalSeconds = Math.floor(remaining / 1000);
        const parts = {
          days: Math.floor(totalSeconds / 86400),
          hours: Math.floor((totalSeconds % 86400) / 3600),
          minutes: Math.floor((totalSeconds % 3600) / 60),
          seconds: totalSeconds % 60,
        };
        Object.entries(parts).forEach(([unit, value]) => {
          const text = unit === 'days' ? String(value) : String(value).padStart(2, '0');
          if (this.values[unit] && this.values[unit].textContent !== text) this.values[unit].textContent = text;
        });
        this.classList.toggle('countdown-timer--urgent', remaining <= URGENT_THRESHOLD_MS);
        this.announce(parts);
      }

      // Screen readers only hear a summary once per minute, never the seconds.
      announce({ days, hours, minutes }) {
        if (!this.status || this.lastMinuteAnnounced === minutes) return;
        this.lastMinuteAnnounced = minutes;
        this.status.textContent = (this.dataset.summary || '')
          .replace('[days]', days)
          .replace('[hours]', hours)
          .replace('[minutes]', minutes);
      }

      // A finished countdown never restarts (EU Omnibus / Dutch unfair commercial practices law).
      expire() {
        this.stop();
        this.classList.add('countdown-timer--expired');
        this.classList.remove('countdown-timer--urgent');
        if (this.dataset.expiredBehavior !== 'message') {
          this.remove();
          return;
        }
        const message = document.createElement('p');
        message.className = 'countdown-timer__expired';
        message.setAttribute('role', 'status');
        message.textContent = this.dataset.expiredMessage || '';
        this.replaceChildren(message);
      }
    }

    customElements.define('countdown-timer', CountdownTimer);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    class FacetResults extends HTMLElement {
    static GRID_KEY = 'hayora:collection-grid';
    static DESKTOP_OPTIONS = ['3', '4', '5'];
    static MOBILE_OPTIONS = ['1', '2'];
    static REGIONS = ['toggle-count', 'filters', 'sort', 'active', 'results', 'pagination-top', 'pagination'];

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.form = this.querySelector('[data-facets-form]');
      this.abortController = null;
      this.defaults = {
        desktop: this.dataset.gridDesktop || '4',
        mobile: this.dataset.gridMobile || '2',
      };

      this.addEventListener('change', this.onChange);
      this.addEventListener('input', this.onInput);
      this.addEventListener('submit', this.onSubmit);
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('toggle', this.onToggle, true);
      document.addEventListener('click', this.onDocumentClick);
      window.addEventListener('popstate', this.onPopState);

      const views = this.querySelector('[data-facets-views]');
      if (views) {
        views.hidden = false;
        this.applyGrid(this.readGrid());
      }
      this.initPriceRanges();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('input', this.onInput);
      this.removeEventListener('submit', this.onSubmit);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('toggle', this.onToggle, true);
      document.removeEventListener('click', this.onDocumentClick);
      window.removeEventListener('popstate', this.onPopState);
    }

    readGrid() {
      const state = { ...this.defaults, layout: 'grid' };
      try {
        const stored = JSON.parse(localStorage.getItem(FacetResults.GRID_KEY) || '{}');
        if (FacetResults.DESKTOP_OPTIONS.includes(stored.desktop)) state.desktop = stored.desktop;
        if (FacetResults.MOBILE_OPTIONS.includes(stored.mobile)) state.mobile = stored.mobile;
        if (stored.layout === 'list') state.layout = 'list';
      } catch {}
      return state;
    }

    writeGrid(state) {
      try {
        localStorage.setItem(FacetResults.GRID_KEY, JSON.stringify(state));
      } catch {}
    }

    applyGrid(state) {
      this.dataset.gridDesktop = state.desktop;
      this.dataset.gridMobile = state.mobile;
      this.dataset.cardLayout = state.layout;
      const isGrid = state.layout === 'grid';
      this.querySelectorAll('[data-view-desktop]').forEach((button) => {
        button.setAttribute('aria-pressed', String(isGrid && button.dataset.viewDesktop === state.desktop));
      });
      this.querySelectorAll('[data-view-mobile]').forEach((button) => {
        button.setAttribute('aria-pressed', String(isGrid && button.dataset.viewMobile === state.mobile));
      });
      this.querySelectorAll('[data-view-list]').forEach((button) => {
        button.setAttribute('aria-pressed', String(!isGrid));
      });
    }

    updateGrid(button) {
      const state = this.readGrid();
      if (button.hasAttribute('data-view-list')) {
        state.layout = 'list';
      } else {
        state.layout = 'grid';
        if (button.dataset.viewDesktop) state.desktop = button.dataset.viewDesktop;
        if (button.dataset.viewMobile) state.mobile = button.dataset.viewMobile;
      }
      this.writeGrid(state);
      this.applyGrid(state);
    }

    get drawer() {
      return this.querySelector('[data-facets-drawer]');
    }

    get sortMenu() {
      return this.querySelector('[data-facets-sort]');
    }

    closeDrawer({ reset = true } = {}) {
      const drawer = this.drawer;
      if (!drawer?.open) return;
      drawer.open = false;
      if (reset) {
        this.form?.reset();
        this.initPriceRanges();
      }
      drawer.querySelector('summary')?.focus();
    }

    closeSort({ focus = false } = {}) {
      const sort = this.sortMenu;
      if (!sort?.open) return;
      sort.open = false;
      if (focus) sort.querySelector('summary')?.focus();
    }

    buildUrl() {
      const params = new URLSearchParams();
      for (const [key, value] of new FormData(this.form)) {
        if (typeof value === 'string' && value.trim() !== '') params.append(key, value);
      }
      const action = new URL(this.form.action, window.location.origin);
      const query = params.toString();
      return `${action.pathname}${query ? `?${query}` : ''}`;
    }

    initPriceRanges() {
      this.querySelectorAll('[data-price-filter]').forEach((filter) => {
        const range = filter.querySelector('[data-price-range]');
        if (!range) return;
        range.hidden = false;
        const max = Number(filter.dataset.rangeMax) || 0;
        const minInput = filter.querySelector('[data-price-min]');
        const maxInput = filter.querySelector('[data-price-max]');
        filter.querySelector('[data-range-min]').value = minInput.value || 0;
        filter.querySelector('[data-range-max]').value = maxInput.value || max;
        this.paintRange(filter);
      });
    }

    paintRange(filter) {
      const max = Number(filter.dataset.rangeMax) || 1;
      const low = Number(filter.querySelector('[data-range-min]').value);
      const high = Number(filter.querySelector('[data-range-max]').value);
      const fill = filter.querySelector('[data-range-fill]');
      fill.style.setProperty('--range-start', `${(low / max) * 100}%`);
      fill.style.setProperty('--range-end', `${100 - (high / max) * 100}%`);
    }

    syncRange(input) {
      const filter = input.closest('[data-price-filter]');
      const max = Number(filter.dataset.rangeMax) || 0;
      const lowSlider = filter.querySelector('[data-range-min]');
      const highSlider = filter.querySelector('[data-range-max]');

      if (input === lowSlider || input === highSlider) {
        if (Number(lowSlider.value) > Number(highSlider.value)) {
          input.value = input === lowSlider ? highSlider.value : lowSlider.value;
        }
        const low = Number(lowSlider.value);
        const high = Number(highSlider.value);
        filter.querySelector('[data-price-min]').value = low > 0 ? low : '';
        filter.querySelector('[data-price-max]').value = high < max ? high : '';
      } else if (input.hasAttribute('data-price-min')) {
        lowSlider.value = input.value || 0;
      } else if (input.hasAttribute('data-price-max')) {
        highSlider.value = input.value || max;
      }
      this.paintRange(filter);
    }

    onInput = (event) => {
      if (event.target.closest('[data-price-filter]')) this.syncRange(event.target);
    };

    onChange = (event) => {
      if (!event.target.form || event.target.form !== this.form) return;
      if (event.target.closest('[data-facets-drawer]')) return;
      if (event.target.matches('[data-sort-native]')) {
        const radio = [...this.form.querySelectorAll('input[name="sort_by"]')].find(
          (input) => input.value === event.target.value
        );
        if (!radio) return;
        radio.checked = true;
        this.render(this.buildUrl());
        return;
      }
      if (event.target.name !== 'sort_by') return;
      this.closeSort({ focus: true });
      this.render(this.buildUrl());
    };

    onSubmit = (event) => {
      if (event.target !== this.form) return;
      event.preventDefault();
      const url = this.buildUrl();
      this.closeDrawer({ reset: false });
      this.render(url);
    };

    onToggle = (event) => {
      if (event.target === this.drawer && this.drawer.open) {
        this.closeSort();
        this.drawer.querySelector('[data-facets-close-button]')?.focus();
      }
    };

    onDocumentClick = (event) => {
      const sort = this.sortMenu;
      if (sort?.open && !sort.contains(event.target)) sort.open = false;
    };

    onClick = (event) => {
      if (event.target.closest('[data-facets-close]')) {
        event.preventDefault();
        this.closeDrawer();
        return;
      }

      const viewButton = event.target.closest('[data-view-desktop], [data-view-mobile], [data-view-list]');
      if (viewButton) {
        this.updateGrid(viewButton);
        return;
      }

      const loadMore = event.target.closest('[data-load-more]');
      if (loadMore) {
        event.preventDefault();
        this.loadMore(loadMore);
        return;
      }

      const loadPrevious = event.target.closest('[data-load-previous]');
      if (loadPrevious) {
        event.preventDefault();
        this.loadPrevious(loadPrevious);
        return;
      }

      const link = event.target.closest('a[data-facet-link]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
      event.preventDefault();
      this.closeDrawer({ reset: false });
      this.render(link.href, { scroll: link.hasAttribute('data-facet-scroll') });
    };

    onKeydown = (event) => {
      if (event.key !== 'Escape') return;
      if (this.drawer?.open) {
        event.preventDefault();
        this.closeDrawer();
      } else if (this.sortMenu?.open) {
        event.preventDefault();
        this.closeSort({ focus: true });
      }
    };

    onPopState = () => {
      this.render(window.location.href, { push: false });
    };

    async fetchDocument(url) {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const separator = url.includes('?') ? '&' : '?';
      const response = await fetch(`${url}${separator}section_id=${encodeURIComponent(this.sectionId)}`, {
        signal: this.abortController.signal,
      });
      if (!response.ok) throw new Error(window.theme.strings.error);
      return new DOMParser().parseFromString(await response.text(), 'text/html');
    }

    async render(url, { push = true, scroll = false } = {}) {
      const results = this.querySelector('[data-facets-region="results"]');
      results?.setAttribute('aria-busy', 'true');
      try {
        const doc = await this.fetchDocument(url);
        this.swapRegions(doc);
        if (push) history.pushState({ facets: true }, '', url);
        if (scroll) this.scrollIntoView({ block: 'start' });
      } catch (error) {
        if (error.name === 'AbortError') return;
        window.theme.toast(error.message || window.theme.strings.error);
      } finally {
        this.querySelector('[data-facets-region="results"]')?.removeAttribute('aria-busy');
      }
    }

    swapRegions(doc) {
      const focusedId = document.activeElement?.id;
      const openGroups = new Map(
        [...this.querySelectorAll('[data-facet-group]')].map((group) => [group.dataset.facetGroup, group.open])
      );

      FacetResults.REGIONS.forEach((name) => {
        const current = this.querySelector(`[data-facets-region="${name}"]`);
        const next = doc.querySelector(`[data-facets-region="${name}"]`);
        if (current && next) current.innerHTML = next.innerHTML;
        else if (current) current.replaceChildren();
      });

      this.querySelectorAll('[data-facet-group]').forEach((group) => {
        const wasOpen = openGroups.get(group.dataset.facetGroup);
        if (wasOpen !== undefined) group.open = wasOpen;
      });

      const count = this.querySelector('[data-facets-count]');
      const nextCount = doc.querySelector('[data-facets-count]');
      if (count && nextCount && count.textContent !== nextCount.textContent) {
        count.textContent = nextCount.textContent;
      }

      this.initPriceRanges();
      if (focusedId) document.getElementById(focusedId)?.focus({ preventScroll: true });
    }

    replaceRegion(doc, name) {
      const current = this.querySelector(`[data-facets-region="${name}"]`);
      const next = doc.querySelector(`[data-facets-region="${name}"]`);
      if (current) current.innerHTML = next?.innerHTML ?? '';
    }

    importChildren(doc, container) {
      const next = doc.querySelector(`[data-facets-append="${container.dataset.facetsAppend}"]`);
      return next ? [...next.children].map((child) => document.importNode(child, true)) : [];
    }

    async loadMore(button) {
      button.setAttribute('aria-busy', 'true');
      try {
        const doc = await this.fetchDocument(button.href);
        const grid = this.querySelector('[data-facets-grid]');
        const previousCount = grid?.children.length ?? 0;
        this.querySelectorAll('[data-facets-append]').forEach((container) => {
          container.append(...this.importChildren(doc, container));
        });
        this.replaceRegion(doc, 'pagination');
        history.replaceState(history.state, '', button.href);
        grid?.children[previousCount]?.querySelector('a[href]')?.focus({ preventScroll: true });
      } catch (error) {
        if (error.name !== 'AbortError') window.theme.toast(error.message || window.theme.strings.error);
      } finally {
        button.removeAttribute('aria-busy');
      }
    }

    async loadPrevious(button) {
      button.setAttribute('aria-busy', 'true');
      try {
        const doc = await this.fetchDocument(button.href);
        const heightBefore = document.documentElement.scrollHeight;
        this.querySelectorAll('[data-facets-append]').forEach((container) => {
          container.prepend(...this.importChildren(doc, container));
        });
        this.replaceRegion(doc, 'pagination-top');
        window.scrollBy(0, document.documentElement.scrollHeight - heightBefore);
      } catch (error) {
        if (error.name !== 'AbortError') window.theme.toast(error.message || window.theme.strings.error);
      } finally {
        button.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('facet-results')) customElements.define('facet-results', FacetResults);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["footer-localization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('footer-localization')) {
    customElements.define(
      'footer-localization',
      class FooterLocalization extends HTMLElement {
        connectedCallback() {
          this.addEventListener('change', this.onChange);
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.onChange);
        }

        onChange = (event) => {
          const form = event.target.closest('form');
          if (form) form.requestSubmit();
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-localization"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('header-disclosure')) return;

    class HeaderDisclosure extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        if (!this.details) return;
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
        this.querySelector('[data-localization-native]')?.addEventListener(
          'change',
          (event) => this.onNativeChange(event.target),
          { signal }
        );
        this.addEventListener(
          'focusout',
          (event) => event.relatedTarget && !this.contains(event.relatedTarget) && this.close(),
          { signal }
        );
        document.addEventListener('click', (event) => !this.contains(event.target) && this.close(), { signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      onKeydown(event) {
        if (event.key !== 'Escape' || !this.details.open) return;
        event.stopPropagation();
        event.preventDefault();
        this.close();
        this.details.querySelector('summary').focus();
      }

      onNativeChange(select) {
        const button = [...this.querySelectorAll(`button[name="${select.dataset.localizationNative}"]`)].find(
          (item) => item.value === select.value
        );
        button?.click();
      }

      close() {
        this.details.open = false;
      }
    }

    customElements.define('header-disclosure', HeaderDisclosure);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('header-predictive-search')) return;

    const DEBOUNCE_MS = 300;
    const MIN_QUERY_LENGTH = 2;
    const RESULT_LIMIT = 8;

    class PredictiveSearch extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.input = this.querySelector('input[type="search"]');
        this.results = this.querySelector('[data-predictive-search-results]');
        this.status = this.querySelector('[data-predictive-search-status]');
        this.clearButton = this.querySelector('[data-search-clear]');
        this.cache = new Map();
        this.debounceTimer = null;
        this.request = null;

        this.input.addEventListener('input', () => this.onInput(), { signal });
        this.input.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
        this.input.addEventListener('focus', () => this.onInput(), { signal });
        this.clearButton?.addEventListener('click', () => this.clear(), { signal });
        this.closest('dialog')?.addEventListener('close', () => this.reset(), { signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.request?.abort();
        clearTimeout(this.debounceTimer);
      }

      get term() {
        return this.input.value.trim();
      }

      onInput() {
        const term = this.term;
        if (this.clearButton) this.clearButton.hidden = term.length === 0;
        clearTimeout(this.debounceTimer);

        if (term.length < MIN_QUERY_LENGTH) {
          this.request?.abort();
          this.hideResults();
          return;
        }

        if (this.cache.has(term)) {
          this.render(this.cache.get(term));
          return;
        }
        this.debounceTimer = setTimeout(() => this.search(term), DEBOUNCE_MS);
      }

      async search(term) {
        this.request?.abort();
        this.request = new AbortController();
        this.results.setAttribute('aria-busy', 'true');
        this.status.textContent = this.dataset.loadingText || '';

        const params = new URLSearchParams({
          q: term,
          section_id: this.dataset.sectionId,
          'resources[type]': 'product,collection,query,page',
          'resources[limit]': String(RESULT_LIMIT),
          'resources[limit_scope]': 'each',
          'resources[options][prefix]': 'last',
        });

        try {
          const response = await fetch(`${this.dataset.url}?${params}`, { signal: this.request.signal });
          if (!response.ok) throw new Error(`Predictive search failed with status ${response.status}`);
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = html.querySelector('[data-predictive-search-content]');
          if (!content) throw new Error('Predictive search response is missing its content');

          this.cache.set(term, content.innerHTML);
          if (this.term === term) this.render(content.innerHTML);
        } catch (error) {
          if (error.name === 'AbortError') return;
          console.error(error);
          this.hideResults();
          this.status.textContent = this.dataset.errorText || '';
        } finally {
          this.results.removeAttribute('aria-busy');
        }
      }

      render(html) {
        this.results.innerHTML = html;
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        this.input.removeAttribute('aria-activedescendant');
        this.status.textContent = this.results.querySelector('[data-predictive-search-count]')?.textContent.trim() || '';
      }

      hideResults() {
        this.results.hidden = true;
        this.results.innerHTML = '';
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
      }

      clear() {
        this.input.value = '';
        this.onInput();
        this.status.textContent = '';
        this.input.focus();
      }

      reset() {
        this.request?.abort();
        clearTimeout(this.debounceTimer);
        this.input.value = '';
        if (this.clearButton) this.clearButton.hidden = true;
        this.hideResults();
        this.status.textContent = '';
      }

      onKeydown(event) {
        if (!['ArrowDown', 'ArrowUp', 'Enter'].includes(event.key) || this.results.hidden) return;
        const options = [...this.results.querySelectorAll('[role="option"]')];
        if (options.length === 0) return;
        const currentIndex = options.findIndex((option) => option.getAttribute('aria-selected') === 'true');

        if (event.key === 'Enter') {
          if (currentIndex === -1) return;
          event.preventDefault();
          options[currentIndex].querySelector('a')?.click();
          return;
        }

        event.preventDefault();
        const step = event.key === 'ArrowDown' ? 1 : -1;
        const fallback = step === 1 ? 0 : options.length - 1;
        const nextIndex = currentIndex === -1 ? fallback : (currentIndex + step + options.length) % options.length;
        this.select(options, nextIndex);
      }

      select(options, index) {
        options.forEach((option, optionIndex) => option.setAttribute('aria-selected', String(optionIndex === index)));
        const selected = options[index];
        this.input.setAttribute('aria-activedescendant', selected.id);
        selected.scrollIntoView({ block: 'nearest' });
      }
    }

    customElements.define('header-predictive-search', PredictiveSearch);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["home-carousel-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('home-carousel')) {
    const SCROLL_EDGE_TOLERANCE_PX = 4;

    class HomeCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.prev = this.querySelector('[data-carousel-prev]');
        this.next = this.querySelector('[data-carousel-next]');
        if (!this.track) return;

        this.onScroll = () => this.update();
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.prev?.addEventListener('click', () => this.scrollByPage(-1));
        this.next?.addEventListener('click', () => this.scrollByPage(1));
        this.resizeObserver = new ResizeObserver(this.onScroll);
        this.resizeObserver.observe(this.track);
        this.onBlockSelect = (event) => {
          const item = [...this.track.children].find((child) => child.contains(event.target));
          if (item) this.scrollToItem(item);
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.update();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver?.disconnect();
      }

      get isRtl() {
        return getComputedStyle(this).direction === 'rtl';
      }

      scrollByPage(direction) {
        const item = this.track.firstElementChild;
        const step = item ? item.getBoundingClientRect().width : this.track.clientWidth;
        const perPage = Math.max(1, Math.floor(this.track.clientWidth / step));
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const sign = this.isRtl ? -direction : direction;
        this.track.scrollBy({ left: sign * step * perPage, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      scrollToItem(element) {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({
          left: element.offsetLeft - this.track.offsetLeft,
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
      }

      update() {
        const { scrollWidth, clientWidth } = this.track;
        const position = Math.abs(this.track.scrollLeft);
        const maxScroll = scrollWidth - clientWidth;
        this.dataset.scrollable = String(maxScroll > SCROLL_EDGE_TOLERANCE_PX);
        if (this.prev) this.prev.disabled = position <= SCROLL_EDGE_TOLERANCE_PX;
        if (this.next) this.next.disabled = position >= maxScroll - SCROLL_EDGE_TOLERANCE_PX;
      }
    }

    customElements.define('home-carousel', HomeCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('product-card')) return;

    const ADDED_FEEDBACK_MS = 2000;
    const REVEAL_STAGGER_MS = 50;
    const REVEAL_MAX_DELAY_MS = 400;
    const HOVER_IMAGE_IDLE_TIMEOUT_MS = 2000;
    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const canHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const afterPageLoad = (callback) => {
      const run = () => {
        if ('requestIdleCallback' in window) requestIdleCallback(callback, { timeout: HOVER_IMAGE_IDLE_TIMEOUT_MS });
        else setTimeout(callback, 0);
      };
      if (document.readyState === 'complete') run();
      else window.addEventListener('load', run, { once: true });
    };

    const createDialog = (className, onClose) => {
      const dialog = document.createElement('dialog');
      dialog.className = `modal ${className}`;
      dialog.setAttribute('scroll-lock', '');
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog || event.target.closest('[data-quick-view-close], [data-notify-close]')) {
          dialog.close();
        }
      });
      dialog.addEventListener('close', () => {
        dialog.replaceChildren();
        onClose();
      });
      document.body.append(dialog);
      return dialog;
    };

    class ProductCardQuickView {
      static dialog = null;
      static trigger = null;

      static ensureDialog() {
        if (this.dialog) return this.dialog;
        this.dialog = createDialog('product-card-quick-view', () => {
          this.trigger?.focus();
          this.trigger = null;
        });
        document.addEventListener('cart:added', () => {
          if (this.dialog.open) this.dialog.close();
        });
        return this.dialog;
      }

      static async open(url, trigger, label) {
        const dialog = this.ensureDialog();
        this.trigger = trigger;
        dialog.replaceChildren();
        dialog.setAttribute('aria-busy', 'true');
        dialog.removeAttribute('aria-labelledby');
        dialog.setAttribute('aria-label', label);
        dialog.showModal();
        try {
          const doc = await window.theme.fetchSection(url, 'quick-view');
          const content = doc.querySelector('[data-quick-view]');
          if (!content) throw new Error(window.theme.strings.error);
          dialog.append(document.importNode(content, true));
          const heading = dialog.querySelector('[data-quick-view-title]');
          if (heading?.id) {
            dialog.removeAttribute('aria-label');
            dialog.setAttribute('aria-labelledby', heading.id);
          }
          dialog.querySelector('[data-quick-view-close]')?.focus();
        } catch (error) {
          dialog.close();
          window.theme.toast(error.message || window.theme.strings.error);
        } finally {
          dialog.removeAttribute('aria-busy');
        }
      }
    }

    const postContactForm = async (form) => {
      const response = await fetch(form.action, { method: 'POST', body: new FormData(form) });
      if (response.url.includes('/challenge')) {
        form.submit();
        return false;
      }
      if (!response.ok || !response.url.includes('contact_posted=true')) throw new Error('contact failed');
      return true;
    };

    class ProductCardNotify {
      static dialog = null;
      static trigger = null;

      static ensureDialog() {
        if (this.dialog) return this.dialog;
        this.dialog = createDialog('product-card-notify', () => {
          this.trigger?.focus();
          this.trigger = null;
        });
        return this.dialog;
      }

      static open(template, { variantId, variantTitle }, trigger) {
        const dialog = this.ensureDialog();
        this.trigger = trigger;
        dialog.replaceChildren(template.content.cloneNode(true));
        const root = dialog.querySelector('[data-notify-root]');
        const prefix = root.querySelector('[data-notify-body-prefix]')?.textContent.trim() || '';
        root.querySelector('[data-notify-variant]').textContent = variantTitle;
        root.querySelector('[data-notify-variant-id]').value = variantId;
        root.querySelector('[data-notify-body]').value = `${prefix}: ${variantTitle} (${variantId})`;
        dialog.setAttribute('aria-labelledby', root.querySelector('[data-notify-title]').id);
        root.querySelector('[data-notify-form]').addEventListener('submit', this.onSubmit);
        dialog.showModal();
        root.querySelector('[data-notify-email]')?.focus();
      }

      static onSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        const root = form.closest('[data-notify-root]');
        const submit = form.querySelector('[type="submit"]');
        const error = root.querySelector('[data-notify-error]');
        error.hidden = true;
        submit.setAttribute('aria-busy', 'true');
        try {
          if (!(await postContactForm(form))) return;
          form.hidden = true;
          root.querySelector('[data-notify-success]').hidden = false;
        } catch {
          error.hidden = false;
        } finally {
          submit.removeAttribute('aria-busy');
        }
      };
    }

    const reveal = {
      observer: null,
      observe(card) {
        if (reducedMotion() || !('IntersectionObserver' in window)) return;
        if (card.getBoundingClientRect().top < window.innerHeight) return;
        card.classList.add('is-reveal-pending');
        this.observer ??= new IntersectionObserver(this.onIntersect, { rootMargin: '100px', threshold: 0.1 });
        this.observer.observe(card);
      },
      unobserve(card) {
        this.observer?.unobserve(card);
      },
      onIntersect(entries, observer) {
        let order = 0;
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          const delay = Math.min(order++ * REVEAL_STAGGER_MS, REVEAL_MAX_DELAY_MS);
          setTimeout(() => entry.target.classList.remove('is-reveal-pending'), delay);
        });
      },
    };

    class ProductCard extends HTMLElement {
      connectedCallback() {
        this.imageIndex = 0;
        this.imageCount = Number(this.querySelector('[data-card-media]')?.dataset.imageCount || 0);
        this.select = this.querySelector('[data-card-select]');
        this.submitButton = this.querySelector('[data-card-submit]');
        this.variantInput = this.querySelector('[data-card-variant-id]');
        this.classList.add('is-enhanced');
        this.addEventListener('click', this.onClick);
        this.addEventListener('submit', this.onSubmit);
        this.addEventListener('pointerenter', this.onPointerEnter);
        this.addEventListener('pointerleave', this.onPointerLeave);
        this.select?.addEventListener('toggle', this.onSelectToggle);
        reveal.observe(this);
        if (this.hasAttribute('data-hover-swap') && canHover()) afterPageLoad(() => this.loadSecondaryImage());
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('submit', this.onSubmit);
        this.removeEventListener('pointerenter', this.onPointerEnter);
        this.removeEventListener('pointerleave', this.onPointerLeave);
        document.removeEventListener('click', this.onOutsideClick);
        document.removeEventListener('keydown', this.onKeydown);
        reveal.unobserve(this);
      }

      get images() {
        return [...this.querySelectorAll('[data-card-image]')];
      }

      loadSecondaryImage() {
        const template = this.querySelector('[data-card-secondary-image]');
        if (!template) return;
        template.before(template.content.cloneNode(true));
        template.remove();
      }

      loadExtraImages() {
        const template = this.querySelector('[data-card-extra-images]');
        if (!template) return;
        template.before(template.content.cloneNode(true));
        template.remove();
      }

      showImage(index) {
        if (this.imageCount < 2) return;
        const next = (index + this.imageCount) % this.imageCount;
        if (next > 0) this.loadSecondaryImage();
        if (next > 1) this.loadExtraImages();
        this.imageIndex = next;
        this.images.forEach((image, position) => image.classList.toggle('is-active', position === next));
      }

      onPointerEnter = (event) => {
        if (event.pointerType !== 'mouse' || !canHover() || !this.hasAttribute('data-hover-swap')) return;
        this.showImage(1);
      };

      onPointerLeave = (event) => {
        if (event.pointerType !== 'mouse') return;
        if (this.hasAttribute('data-hover-swap')) this.showImage(0);
        if (this.select?.open) this.select.open = false;
      };

      onSelectToggle = () => {
        if (this.select.open) {
          document.addEventListener('click', this.onOutsideClick);
          document.addEventListener('keydown', this.onKeydown);
        } else {
          document.removeEventListener('click', this.onOutsideClick);
          document.removeEventListener('keydown', this.onKeydown);
        }
      };

      onOutsideClick = (event) => {
        if (!this.select.contains(event.target)) this.select.open = false;
      };

      onKeydown = (event) => {
        if (event.key !== 'Escape') return;
        this.select.open = false;
        this.select.querySelector('summary')?.focus();
      };

      onClick = (event) => {
        const step = event.target.closest('[data-card-step]');
        if (step) {
          event.preventDefault();
          this.showImage(this.imageIndex + Number(step.dataset.cardStep));
          return;
        }

        const quickView = event.target.closest('[data-quick-view-trigger]');
        if (quickView) {
          event.preventDefault();
          if (this.select) this.select.open = false;
          const label = quickView.textContent.replace(/\s+/g, ' ').trim() || this.dataset.productTitle;
          ProductCardQuickView.open(this.dataset.productUrl, quickView, label);
          return;
        }

        const notify = event.target.closest('[data-card-notify]');
        if (notify) {
          this.openNotify(event, notify.dataset.variantId, notify.dataset.variantTitle, notify);
          return;
        }

        const option = event.target.closest('[data-card-option]');
        if (option) this.onOptionClick(event, option);
      };

      openNotify(event, variantId, variantTitle, trigger) {
        const template = this.querySelector('[data-notify-template]');
        if (!template) return;
        event.preventDefault();
        if (this.select) this.select.open = false;
        ProductCardNotify.open(template, { variantId, variantTitle }, trigger);
      }

      onOptionClick(event, option) {
        if (option.getAttribute('aria-disabled') === 'true') {
          this.openNotify(event, option.dataset.variantId, option.dataset.variantTitle, this.select.querySelector('summary'));
          return;
        }
        event.preventDefault();
        this.select.querySelectorAll('[data-card-option]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === option));
        });
        this.variantInput.value = option.dataset.variantId;
        this.select.querySelector('[data-card-select-label]').textContent = option.dataset.label;
        this.select.open = false;
        if (this.submitButton) {
          this.submitButton.disabled = false;
          this.submitButton.type = 'submit';
          const label = this.submitButton.querySelector('[data-card-submit-label]');
          if (label) this.renderLabel(label, null, this.submitButton.dataset.labelShop);
        }
        this.submitButton?.focus();
      }

      onSubmit = async (event) => {
        const form = event.target.closest('[data-product-card-form]');
        if (!form || !window.theme?.cart) return;
        event.preventDefault();
        const submitter = event.submitter || this.submitButton;
        const variantId = submitter?.name === 'id' ? submitter.value : this.variantInput?.value;
        if (!variantId) return;

        const labelNode = submitter?.querySelector('[data-card-submit-label]');
        const originalLabel = labelNode?.textContent ?? '';
        submitter?.setAttribute('aria-busy', 'true');
        if (labelNode) this.renderLabel(labelNode, 'spinner', this.dataset.addingLabel);

        try {
          await window.theme.cart.add({ id: Number(variantId), quantity: 1 });
          if (labelNode) {
            this.renderLabel(labelNode, 'check', this.dataset.addedLabel);
            setTimeout(() => this.renderLabel(labelNode, null, originalLabel), ADDED_FEEDBACK_MS);
          }
        } catch (error) {
          if (labelNode) this.renderLabel(labelNode, null, originalLabel);
          window.theme.toast(error.message || window.theme.strings.error);
        } finally {
          submitter?.removeAttribute('aria-busy');
        }
      };

      renderLabel(node, icon, text) {
        node.replaceChildren();
        if (icon === 'spinner') {
          const spinner = document.createElement('span');
          spinner.className = 'product-card__spinner';
          spinner.setAttribute('aria-hidden', 'true');
          node.append(spinner);
        } else if (icon === 'check') {
          const check = this.querySelector('[data-card-check]');
          if (check) node.append(check.content.cloneNode(true));
        }
        node.append(text || '');
      }
    }

    customElements.define('product-card', ProductCard);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('[data-gallery-slides]');
      this.zoomDialog = this.querySelector('[data-zoom-dialog]');
      this.visibility = new Map();
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.addEventListener('click', (event) => this.onClick(event), { signal });
      this.zoomDialog?.addEventListener('keydown', (event) => this.onZoomKeydown(event), { signal });
      if (this.slider) this.observeSlides();
      this.paintBackdropBands();
      this.loadModelViewer();
      if (this.dataset.layout === 'carousel') this.publishTopOffset(signal);
    }

    publishTopOffset(signal) {
      const update = () => {
        const top = Math.max(this.getBoundingClientRect().top + window.scrollY, 0);
        this.style.setProperty('--gallery-top-offset', `${Math.round(top)}px`);
      };
      update();
      window.addEventListener('resize', update, { signal });
      window.addEventListener('load', update, { once: true, signal });
    }

    // Letterboxed photos blend into the slide when the space beside them repeats their own edge columns
    // (the studio backdrop darkens and lightens vertically, so one colour leaves a seam) and the space
    // above and below takes their top and bottom row colour.
    paintBackdropBands() {
      this.backdrops = new Map();
      this.querySelectorAll('[data-backdrop-src]').forEach((slide) => {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.addEventListener('load', () => {
          const backdrop = ProductGallery.readBackdrop(image);
          if (!backdrop) return;
          this.backdrops.set(slide, backdrop);
          this.paintBackdrop(slide);
        });
        image.src = slide.dataset.backdropSrc;
      });
      this.bandObserver = new ResizeObserver(() => this.backdrops.forEach((_, slide) => this.paintBackdrop(slide)));
      this.querySelectorAll('[data-backdrop-src] .product-gallery__image').forEach((photo) => {
        this.bandObserver.observe(photo);
      });
    }

    paintBackdrop(slide) {
      const backdrop = this.backdrops.get(slide);
      const photo = slide.querySelector('.product-gallery__image');
      if (!backdrop || !photo) return;
      const slideBox = slide.getBoundingClientRect();
      const photoBox = photo.getBoundingClientRect();
      if (!slideBox.height || !photoBox.height) return;
      const top = photoBox.top - slideBox.top;
      const bottom = top + photoBox.height;
      const column = (stops) => `linear-gradient(${stops.join(', ')})`;
      slide.style.background = [
        `${column(backdrop.left)} left ${top}px / 50% ${photoBox.height}px no-repeat`,
        `${column(backdrop.right)} right ${top}px / 50% ${photoBox.height}px no-repeat`,
        `linear-gradient(${backdrop.top} ${bottom / 2 + top / 2}px, ${backdrop.bottom} 0)`,
      ].join(', ');
    }

    static readBackdrop(image) {
      const canvas = document.createElement('canvas');
      canvas.width = image.naturalWidth;
      canvas.height = image.naturalHeight;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context || !canvas.width || !canvas.height) return null;
      context.drawImage(image, 0, 0);
      try {
        const rgb = ([red, green, blue]) => `rgb(${red} ${green} ${blue})`;
        const column = (x) => {
          const data = context.getImageData(x, 0, 1, canvas.height).data;
          const stops = [];
          for (let index = 0; index < data.length; index += 4) {
            const position = ((index / 4 + 0.5) / canvas.height) * 100;
            stops.push(`${rgb(data.slice(index, index + 3))} ${position.toFixed(1)}%`);
          }
          return stops;
        };
        const row = (y) => {
          const data = context.getImageData(0, y, canvas.width, 1).data;
          const total = [0, 0, 0];
          for (let index = 0; index < data.length; index += 4) {
            total[0] += data[index];
            total[1] += data[index + 1];
            total[2] += data[index + 2];
          }
          return rgb(total.map((sum) => Math.round(sum / canvas.width)));
        };
        return { left: column(0), right: column(canvas.width - 1), top: row(0), bottom: row(canvas.height - 1) };
      } catch {
        return null;
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.slideObserver?.disconnect();
      this.bandObserver?.disconnect();
    }

    get slides() {
      if (!this.slider) return [];
      const items = [...this.slider.children];
      return items
        .map((slide, index) => ({ slide, index, order: Number(slide.style.order || 0) }))
        .sort((a, b) => a.order - b.order || a.index - b.index)
        .map(({ slide }) => slide);
    }

    get zoomItems() {
      const imageIds = this.slides.map((slide) => slide.dataset.mediaId);
      const items = [...this.querySelectorAll('[data-zoom-item]')];
      return imageIds.map((id) => items.find((item) => item.dataset.zoomItem === id)).filter(Boolean);
    }

    get scrollBehavior() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    get isHorizontal() {
      return this.slider.scrollWidth > this.slider.clientWidth + 1;
    }

    onClick(event) {
      const step = event.target.closest('[data-gallery-step]');
      if (step) return this.stepSlide(Number(step.dataset.galleryStep));

      const thumb = event.target.closest('[data-gallery-thumb]');
      if (thumb) return this.goToSlide(this.getSlide(thumb.dataset.galleryThumb));

      const zoomTrigger = event.target.closest('[data-zoom-open]');
      if (zoomTrigger) return this.openZoom(zoomTrigger.dataset.zoomOpen);

      const zoomStep = event.target.closest('[data-zoom-step]');
      if (zoomStep) return this.stepZoom(Number(zoomStep.dataset.zoomStep));

      const zoomThumb = event.target.closest('[data-zoom-thumb]');
      if (zoomThumb) return this.showZoomItem(zoomThumb.dataset.zoomThumb);

      if (this.zoomDialog?.open && !event.target.closest('img, button')) this.zoomDialog.close();
    }

    getSlide(mediaId) {
      return this.slider?.querySelector(`[data-media-id="${CSS.escape(String(mediaId))}"]`);
    }

    stepSlide(direction) {
      const slides = this.slides;
      const index = slides.indexOf(this.activeSlide) + direction;
      if (index < 0 || index >= slides.length) return;
      this.goToSlide(slides[index]);
    }

    goToSlide(slide) {
      if (!slide) return;
      if (this.isHorizontal) {
        this.slider.scrollTo({ left: slide.offsetLeft - this.slider.offsetLeft, behavior: this.scrollBehavior });
      } else {
        slide.scrollIntoView({ behavior: this.scrollBehavior, block: 'center' });
      }
      this.setActive(slide);
    }

    showMedia(mediaId) {
      const slide = this.getSlide(mediaId);
      if (!slide) return;
      [...this.slider.children].forEach((item) => item.style.removeProperty('order'));
      this.querySelectorAll('.product-gallery__thumbnail-item').forEach((item) => item.style.removeProperty('order'));
      slide.style.order = '-1';
      this.querySelector(`[data-gallery-thumb="${CSS.escape(String(mediaId))}"]`)
        ?.closest('.product-gallery__thumbnail-item')
        ?.style.setProperty('order', '-1');
      if (this.isHorizontal) this.slider.scrollTo({ left: 0, behavior: 'auto' });
      this.setActive(slide);
    }

    observeSlides() {
      this.slideObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => this.visibility.set(entry.target, entry.intersectionRatio));
          let best = null;
          let bestRatio = 0;
          this.visibility.forEach((ratio, slide) => {
            if (ratio > bestRatio) {
              best = slide;
              bestRatio = ratio;
            }
          });
          if (best) this.setActive(best);
        },
        { threshold: [0, 0.25, 0.5, 0.75, 1] }
      );
      [...this.slider.children].forEach((slide) => this.slideObserver.observe(slide));
    }

    setActive(slide) {
      this.activeSlide = slide;
      const slides = this.slides;
      const index = slides.indexOf(slide);
      const current = this.querySelector('[data-gallery-current]');
      if (current) current.textContent = String(index + 1);
      const prev = this.querySelector('[data-gallery-step="-1"]');
      const next = this.querySelector('[data-gallery-step="1"]');
      if (prev) prev.hidden = index <= 0;
      if (next) next.hidden = index >= slides.length - 1;
      this.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        thumb.setAttribute('aria-current', String(thumb.dataset.galleryThumb === slide.dataset.mediaId));
      });
      this.querySelectorAll('.product-gallery__slide video').forEach((video) => {
        if (!slide.contains(video)) video.pause();
      });
    }

    openZoom(mediaId) {
      if (!this.zoomDialog) return;
      this.showZoomItem(mediaId);
      this.zoomDialog.showModal();
    }

    showZoomItem(mediaId) {
      const items = this.zoomItems;
      const index = Math.max(0, items.findIndex((item) => item.dataset.zoomItem === String(mediaId)));
      this.zoomIndex = index;
      items.forEach((item, itemIndex) => {
        item.hidden = itemIndex !== index;
      });
      const current = this.querySelector('[data-zoom-current]');
      if (current) current.textContent = String(index + 1);
      this.querySelectorAll('[data-zoom-thumb]').forEach((thumb) => {
        thumb.setAttribute('aria-current', String(thumb.dataset.zoomThumb === items[index]?.dataset.zoomItem));
      });
    }

    stepZoom(direction) {
      const items = this.zoomItems;
      if (!items.length) return;
      const index = (this.zoomIndex + direction + items.length) % items.length;
      this.showZoomItem(items[index].dataset.zoomItem);
    }

    onZoomKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.stepZoom(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.stepZoom(1);
      }
    }

    loadModelViewer() {
      const models = this.querySelectorAll('model-viewer');
      if (!models.length || !window.Shopify?.loadFeatures) return;
      window.Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: (error) => {
            if (error || !window.Shopify.ModelViewerUI) return;
            models.forEach((model) => new window.Shopify.ModelViewerUI(model));
          },
        },
      ]);
    }
  }

  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-button"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('wishlist-button')) return;

    const whenThemeReady = (callback) => {
      if (window.theme?.wishlist) return callback();
      document.addEventListener('DOMContentLoaded', () => window.theme?.wishlist && callback(), { once: true });
    };

    class WishlistButton extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;
        this.button.addEventListener('click', this.onClick);
        document.addEventListener('wishlist:updated', this.onUpdated);
        whenThemeReady(() => this.render(window.theme.wishlist.has(this.dataset.handle)));
      }

      disconnectedCallback() {
        document.removeEventListener('wishlist:updated', this.onUpdated);
      }

      onClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!window.theme?.wishlist) return;
        const isSaved = window.theme.wishlist.toggle(this.dataset.handle);
        const message = isSaved ? this.dataset.addedMessage : this.dataset.removedMessage;
        if (message) window.theme.toast(message);
      };

      onUpdated = (event) => {
        const handles = event.detail?.handles;
        if (Array.isArray(handles)) this.render(handles.includes(this.dataset.handle));
      };

      render(isSaved) {
        this.button.setAttribute('aria-pressed', String(Boolean(isSaved)));
      }
    }

    customElements.define('wishlist-button', WishlistButton);
  })();
  } catch(e) { console.error(e); }
})();

})();
